import { AloftPrice, isUndefined } from '@aloft/toolkit-shared';

export const calculateUnitRateAdjustment = ({
  subjectUnitAmount,
  compUnitAmount,
  unitRate,
}: {
  subjectUnitAmount?: number;
  compUnitAmount?: number;
  unitRate?: AloftPrice;
}): AloftPrice | undefined => {
  // If both amounts are missing, return undefined
  if (isUndefined(subjectUnitAmount) && isUndefined(compUnitAmount)) {
    return undefined;
  }

  // If unit rate is not configured, return undefined
  if (isUndefined(unitRate)) {
    return undefined;
  }

  // Treat undefined as 0 for calculation purposes
  const subjectAmount = subjectUnitAmount ?? 0;
  const compAmount = compUnitAmount ?? 0;
  const unitDifference = subjectAmount - compAmount;

  if (unitDifference === 0) {
    return undefined;
  }

  return unitRate.mul(unitDifference);
};
